import React, { useState, useEffect, useCallback } from 'react';
import { Button, Spin } from '@kufox/mui';
import _ from 'lodash';

let timer = null;

/**
 * @param {onChange} function onChange 回调函数 默认 空函数
 * @param {disabled} Boolean 是否 disable 默认 true
 * @param {countTime} number 倒计时时间 默认 30
 * @param {countTimeOver} function 倒计时结束执行
 * @param {localTimeKey} string 本地的倒计时key
 * @param {countText} string 按钮的文字
 * @param {countLabel} string 倒计时的单位
 */
export default function SendCodeBtn(props = {}) {
  const {
    variant = 'contained',
    onChange = _.noop,
    disabled = true,
    countTime,
    countTimeOver = _.noop,
    loading = false,
    countText,
    countLabel = 's',
    localTimeKey,
    ...other
  } = props;

  const [countTimer, setCountTimer] = useState(countTime);

  const isCount = countTimer > 0;

  const startCount = useCallback((seconds) => {
    setCountTimer(seconds);
    if (seconds !== 0) {
      timer = _.delay(() => {
        startCount(seconds - 1);
      }, 1000);
    } else {
      clearTimeout(timer);
      countTimeOver();
    }
  }, []);

  useEffect(() => {
    return clearTimeout(timer);
  }, []);

  useEffect(() => {
    if (countTime && countTime.time > 0) {
      startCount(countTime.time);
    }
  }, [countTime]);

  const handleSendCode = () => {
    onChange();
  };

  return (
    <Button
      {...other}
      onClick={handleSendCode}
      variant={variant}
      type="primary"
      disabled={Boolean(disabled) || Boolean(isCount)}
    >
      {loading ? (
        <Spin />
      ) : isCount ? (
        <span style={{ fontSize: '12px' }}>{`${countTimer} ${countLabel || null}`}</span>
      ) : (
        <span style={{ fontSize: '12px' }}>{countText}</span>
      )}
    </Button>
  );
}
